export default "__VITE_ASSET__C0$bC5dk__"